import {LOADING, LOADED} from '../actions/actionTypes';

export const initialState = {
  isLoading: false,
};

export default (state = initialState, action = null) => {
  switch (action.type) {
    case LOADING:
      return {
        ...state,
        isLoading: true,
      };
    case LOADED:
      return {
        ...state,
        isLoading: false,
      };
    default:
      return state;
  }
};
